<script lang="ts">
  interface Props {
    error: string;
  }

  let { error }: Props = $props();
</script>

<p class="text-center p-3 fst-italic text-danger mb-0">
  {error}
</p>
